<template>
    <div class="flex items-center justify-between gap-1 delta-value-renderer">
        <span v-if="numericValue !== 0 && !isNA" :class="valueClass">
            <ChevronUpIcon v-if="numericValue > 0" class="h-4 w-4" />
            <ChevronDownIcon v-else class="h-4 w-4" />
        </span>
        <span v-else></span>
        <span :class="[valueClass, isNA ? 'delta-value-renderer-na' : 'delta-value-renderer-span']">
            {{ formattedValue }}
        </span>
    </div>
</template>

<script setup lang="ts">
import type { ICellRendererParams } from 'ag-grid-enterprise';
import ChevronDownIcon from '~/assets/svgs/ChevronDownIcon.vue';
import ChevronUpIcon from '~/assets/svgs/ChevronUpIcon.vue';
import { useTranslate } from '~/composables/useTranslate'
const { t } = useTranslate();

interface IDeltaValueRendererParams extends ICellRendererParams {
    referenceColId?: string;
}

const props = defineProps<{
    params: IDeltaValueRendererParams;
}>();

const numericValue = computed(() => {
    let numeric = props.params.value;

    if (props.params.referenceColId) {
        numeric = props.params.api.getCellValue({
            colKey: props.params.referenceColId,
            rowNode: props.params.node
        });
    }

    return typeof numeric === 'number' ? numeric : Number.parseFloat(numeric) || 0;
});

const formattedValue = computed(() => {
    return props.params.valueFormatted || props.params.value || '';
});

const isNA = computed(() => {
    return formattedValue.value === t('not_available') || +numericValue.value === 0;
});

const valueClass = computed(() => {
    if (isNA.value) {
        return 'text-gray-600';
    }

    if (numericValue.value > 0) {
        return 'text-green-600';
    } else if (numericValue.value < 0) {
        return 'text-red-300';
    }

    return 'text-green-600';
});
</script>
